import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../actions/ProductActions.js';
import { ProductCarouselSkeleton } from "./HomeSkeletons";
import ProductCard from './ProductCard';
import { useNavigate } from 'react-router-dom';
import '../styles/recommendations.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Recommendations = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, products = [], error } = useSelector((state) => state.products || {});
  const scrollRef = useRef(null);

  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  const handleProductClick = (product) => {
    navigate(`/product/${product.slug || product.product_id}`);
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  if (loading)
    return (
      <ProductCarouselSkeleton
        title="Recommendations"
        variant="recommendations"
      />
    );
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="recommendations-section">
      <div className="recommendations-title-and-chevron">
        <h3 className="recommendations-title">Recommendations</h3>
        <div className="recommendations-chevrons">
          <button className="nav-arrow" onClick={scrollLeft}><FaChevronLeft /></button>
          <button className="nav-arrow" onClick={scrollRight}><FaChevronRight /></button>
        </div>
      </div>
      <div className="recommendations-grid" ref={scrollRef}>
        {Array.isArray(products) && products.length > 0 ? (
          products.map((product) => (
            <div
              key={product.product_id}
              className="recommendations-product-item"
              onClick={() => handleProductClick(product)}
            >
              <ProductCard product={product} />
            </div>
          ))
        ) : (
          <div className="no-recommendations">No recommendations available</div>
        )}
      </div>
    </div>
  );
};

export default Recommendations;
